<div class="row">
	<div id="divTestSuiteDetails" class="col-md-12">
		<h4>Details for test suite {{ testSuite?.itemNo }} - {{ testSuite?.name }}</h4>
		<table class="table">
			<tbody>
				<tr>
					<td width="20%">Test suite UID</td>
					<td class="bold">{{ testSuite?.testSuiteUid }}</td>
				</tr>
				<tr>
					<td>Version number</td>
					<td>
						<mat-form-field class="dropdown-padding">
							<select matNativeControl [ngModel]="selectedVersion" (change)="getVersion($event.target.value)">
								<option *ngFor="let version of testSuite?.versions" value="{{ version.versionNo }}">
									<span *ngIf="!version.validTo">
										&nbsp;{{ version.versionNo }}&nbsp;&nbsp;&nbsp;&nbsp;({{ version.regTime | date: 'yyyy-MM-dd HH:mm:ss' }} - {{ version.regBy.toUpperCase() }}) latest
									</span>
									<span *ngIf="version.validTo">
										&nbsp;{{ version.versionNo }}&nbsp;&nbsp;&nbsp;&nbsp;({{ version.regTime | date: 'yyyy-MM-dd HH:mm:ss' }} - {{ version.regBy.toUpperCase() }})
									</span>
								</option>
							</select>
						</mat-form-field>
					</td>
				</tr>
				<tr>
					<td>Creation time for this version</td>
					<td class="bold">{{ testSuite?.regTime | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
				</tr>
				<tr>
					<td>Owner</td>
					<td class="bold">{{ testSuite?.owners?.join(', ') }}</td>
				</tr>
				<tr>
					<td>UF</td>
					<td>
						<table class="no-margin bold">
							<tr *ngFor="let uf of testSuite?.ufs">
								<td width="70px" class="no-padding">UF{{ uf.ufNumber }}</td>
								<td class="no-padding">{{ uf.name }}</td>
							</tr>
						</table>
					</td>
				</tr>
				<tr>
					<td>Product properties</td>
					<td>
						<table class="no-margin bold">
							<tr *ngFor="let productProp of testSuite?.productProperties">
								<td width="200px" class="no-padding">{{ productProp.name }}</td>
								<td class="no-padding">Category: {{ productProp.productCategoryName }}</td>
							</tr>
						</table>
					</td>
				</tr>
				<tr>
					<td>Offboard components</td>
					<td class="bold">
						<span *ngIf="offboardComponentValues?.length > 0">{{ offboardComponentValues }}</span>
					</td>
				</tr>
				<tr>
					<td style="vertical-align: top">Description</td>
					<td><div [innerHTML]="testSuite?.descriptionSafeHtml"></div></td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
